<template>
<div>
    <patent-translate-form ref="patentTranslateFormModal">
    </patent-translate-form>
    <!-- modal -->
    <b-modal id="jobNextFormModal" centered size="lg" no-close-on-backdrop ref="jobNextFormModal" :title="$t('jobNext.info') + ' : ' + this.recordNo" :cancel-title="$t('others.cancel_title')" :ok-title="$t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
            <b-row>
                <b-col class="col-lg-11">
                    <b-form>
                        <validation-provider :name="$t('jobNext.job_status_path')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                            <label for="job-next-status-relation-detail-input">{{$t("jobNext.job_status_path")}}</label>
                            <b-form-select @change="giveDates()" size="sm" v-model="jobNextStatusRelationDetailSelect" value-field="id" text-field="name" :options="jobNextStatusRelationDetailOption" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form>
                </b-col>
                <b-col class="col-lg-1">
                    <b-form>
                        <br />
                        <b-button variant="outline-primary" size="sm" v-b-tooltip.html :title="$t('others.close_job')" @click="closeJob()">
                            <feather-icon icon="CheckSquareIcon" size="13" class="align-middle" />
                        </b-button>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-4 mt-1">
                    <b-form>
                        <label for="job-next-date-input">{{ $t("jobNext.date") }}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="date" @input="giveDates()"></CustomDatePicker>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4 mt-1">
                    <b-form>
                        <label for="job-next-next-job-deadline-input">{{$t("jobNext.next_job_deadline")}}</label>
                        <CustomDatePicker :datePickerValidateOption="0" v-model="nextJobDeadline" @input="checkDateWeekendOrHoliday()"></CustomDatePicker>
                    </b-form>
                </b-col>
                <b-col class="col-lg-4 mt-1">
                    <b-form>
                        <label for="job-next-tpmk-deadline-input">{{$t("jobNext.tpmk_deadline")}}</label>
                        <b-form-datepicker :disabled="!(this.employeeDepartmentId == 6 || this.employeeId == 115)" today-button :label-today-button="$t('dateTime.today')" id="date" v-model="tpmkDeadline" :defaultDate="null" reset-button class="mb-1" size="sm" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" :locale="$i18n.locale" :label-reset-button="$t('dateTime.reset')" :label-no-date-selected="$t('dateTime.select_date')" />
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6 mt-1" v-if="hiddenCheckDocumentNo">
                    <label for="job-next-document-entry-no-input">{{ $t("jobNext.document_entry_no")}}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('jobNext.document_entry_no')" :rules="isRequiredDocumentNo ? 'required' : ''">
                            <b-form-input id="job-next-document-entry-no-input" size="sm" v-model="documentNo" maxlength="50" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col class="col-lg-6 mt-1">
                    <b-form>
                        <label for="job-next-employee-input">{{$t("jobNext.employee")}}</label>
                        <b-form-select size="sm" v-model="employeeSelect" value-field="id" text-field="name" :options="employeeOption" />
                    </b-form>
                </b-col>
            </b-row>
            <b-row v-if="hiddenCheck">
                <b-col class="col-lg-6 mt-1">
                    <label for="job-next-application-no-input">{{$t("jobNext.application_no")}}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('jobNext.application_no')" :rules="isRequired2 ? 'required' : ''">
                            <b-form-input id="job-next-application-no-input" size="sm" v-model="applicationNo" maxlength="12" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="hiddenTrademarkObjectionToUsRow">
                <b-col class="col-lg-4 mt-1">
                    <b-form>
                        <label for="trademarkObjectionToUs-input">{{ $t("jobNext.date") }}</label>
                        <CustomDatePicker :datePickerValidateOption="1" v-model="trademarkObjectionToUsDate"></CustomDatePicker>
                    </b-form>
                </b-col>

                <b-col class="col-lg-4 mt-1">
                    <label for="job-next-owner-input">{{$t("jobNext.owner")}}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('jobNext.owner')" rules="required">
                            <b-form-input id="job-next-owner-input" size="sm" v-model="trademarkObjectionToUsOwner" maxlength="200" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

                <b-col class="col-lg-4 mt-1">
                    <label for="job-next-ground-of-objection-input">{{$t("jobNext.ground_of_objection")}}</label>
                    <b-form-group>
                        <validation-provider #default="{ errors }" :name="$t('jobNext.ground_of_objection')" rules="required">
                            <b-form-input id="job-next-ground-of-objection-input" size="sm" v-model="trademarkObjectionToUsGroundOfObjection" maxlength="200" :state="errors.length > 0 ? false : null" />
                            <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                    </b-form-group>
                </b-col>

            </b-row>
            <!-- STOCK-803 -->
            <b-row v-if="hiddenPatentTranslateRow">
                <b-col class="col-lg-6 mt-1">
                    <b-form-group>
                        <div class="d-flex align-items-center">
                            <b-button style="float:right;" size="sm" variant="outline-primary" @click="showPatentTranslateForm(0)">{{ $t('jobNext.translate_add') }}</b-button>
                        </div>
                    </b-form-group>
                </b-col>
            </b-row>
            <!-- END OF STOCK-803 -->
            <b-row>
                <b-col class="col-lg-12">
                    <b-form>
                        <label for="job-next-note-input">{{ $t("jobNext.note") }}</label>
                        <b-form-textarea size="sm" id="job-next-note-input" v-model="note" rows="3" max-rows="8" maxlength="250" />
                    </b-form>
                </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getJobList: {
            type: Function,
        },
        getJobReportList: {
            type: Function,
        },
        getRecordInfo: {
            type: Function,
        },
    },
    data() {
        return {
            id: 0,
            moduleId: 0,
            jobNextStatusRelationDetailOption: [],
            jobNextStatusRelationDetailSelect: 0,
            documentId: 0,
            jobDate: 0,
            nextJobDeadline: null,
            tpmkDeadline: null,
            date: null,
            employeeOption: [],
            employeeSelect: 0,
            note: "",
            jobId: 0,
            documentNo: "",
            isRequiredDocumentNo: false,
            hiddenCheckDocumentNo: false,
            applicationNo: "",
            hiddenCheck: true,
            isRequired2: false,
            recordNo: "",
            employeeId:0,
            //formerJobHistoryTmpkDeadline: null,
            hiddenTrademarkObjectionToUsRow: false,
            trademarkObjectionToUsDate: null,
            trademarkObjectionToUsOwner: "",
            trademarkObjectionToUsGroundOfObjection: "",
            employeeDepartmentId: 0,
            hiddenPatentTranslateRow: false,
        };
    },
    methods: {
        checkDateWeekendOrHoliday() {
            const data = {
                date: this.nextJobDeadline
            }

            const controller = {
                name: 'Common',
                actionName: 'CheckDateWeekendOrHoliday'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultMessage != null) {
                    this.$CustomAlert(this.$t("alerts.the_date_you_choose_falls_on_a_holiday"), "warning")
                }
            })
        },
        giveDates() {
            this.nextJobDeadline = null;
            this.tpmkDeadline = null;
            if (this.jobNextStatusRelationDetailSelect > 0) {
                const data = {
                    jobId: this.jobId,
                    jobStatusRelationId: this.jobNextStatusRelationDetailSelect,
                    jobHistoryDate: this.date,
                };
                const controller = {
                    name: "JobHistory",
                    actionName: "CalculateNextDateByJobStatusRelationId",
                };
                const payload = {
                    data: data,
                    controller: controller,
                };
                this.$store
                    .dispatch("moduleAuth/customService", payload)
                    .then((response) => {
                        this.nextJobDeadline = response.data.nextJobReminderDate;
                        this.tpmkDeadline = response.data.tpmkReminderDate;
                        //STOCK-1036 TPE-OUT And Module Check 
                        // //Changelog : This Method changed with new Attribute on JobStatus named  : isApplicationNoRequired by STOCK-1544. 
                        if (response.data.applicationCheck == true) {
                            this.hiddenCheck = true;
                            this.isRequired2 = true;
                        } else {
                            this.hiddenCheck = false;
                            this.isRequired2 = false;
                        }
                        //
                    });

                let jobRelation = this.jobNextStatusRelationDetailOption.find(
                    (p) => p.id == this.jobNextStatusRelationDetailSelect
                );

                if (jobRelation != null && jobRelation.jobStatusPathId == 6) {
                    this.isRequiredDocumentNo = true;
                    this.hiddenCheckDocumentNo = true;
                } else {
                    this.isRequiredDocumentNo = false;
                    this.hiddenCheckDocumentNo = false;
                }

                //if (this.tpmkDeadline == null) {
                //    this.tpmkDeadline = this.formerJobHistoryTmpkDeadline
                //}

                if (this.jobNextStatusRelationDetailSelect == 3) {
                    this.hiddenTrademarkObjectionToUsRow = true;
                } else {
                    this.hiddenTrademarkObjectionToUsRow = false;
                }
                //STOCK-803
                if (jobRelation.jobStatusId == 281 && this.moduleId == 4) {
                    this.hiddenPatentTranslateRow = true
                }
                //
            }
        },
        //STOCK-803
        showPatentTranslateForm() {
            this.$refs.patentTranslateFormModal.showInfo(0, this.recordId)
        },
        //
        showInfo(jobId, recordId, moduleId, recordNo, documentId, jobDate) {
            this.employeeId = localStorage.getItem("EmployeeId")
            this.employeeDepartmentId = localStorage.getItem('DepartmentId')
            this.$refs["jobNextFormModal"].show();
            this.jobId = jobId;
            this.recordId = recordId;
            this.moduleId = moduleId;
            this.recordNo = recordNo;
            this.documentId = documentId;

            const data = {
                id: 0,
                jobId: jobId,
            };
            const controller = {
                name: "JobHistory",
            };
            const payload = {
                data: data,
                controller: controller,
            };
            this.$store.dispatch("moduleAuth/getInfo", payload).then((response) => {
                if (response.data.resultStatus == true) {
                    if (jobDate != null)
                        this.date = jobDate
                    else if (response.data.jobHistoryDto.date != null) {
                        this.date = response.data.jobHistoryDto.date;
                    } else this.date = new Date();

                    if (response.data.jobStatusList != null) {
                        this.jobNextStatusRelationDetailOption = response.data.jobStatusList;
                        if (response.data.jobStatusList.length == 1 && response.data.jobHistoryDto.jobStatusRelationId == 0) {
                            this.jobNextStatusRelationDetailSelect = response.data.jobStatusList[0].id;
                        } else {
                            this.jobNextStatusRelationDetailSelect = response.data.jobHistoryDto.jobStatusRelationId;
                        }
                        this.giveDates()
                    }
                    this.documentNo = response.data.jobHistoryDto.documentNo;
                    this.jobNextStatusRelationDetailOption.splice(0, 0, this.$nullSelected());
                    this.employeeOption = response.data.employeeList;
                    this.employeeOption.splice(0, 0, this.$nullSelected());
                    if (response.data.jobHistoryDto.employeeId != 0) {
                        this.employeeSelect = response.data.jobHistoryDto.employeeId;
                    } else {
                        this.employeeSelect = localStorage.getItem("EmployeeId");
                    }
                    this.note = response.data.jobHistoryDto.note;

                    //this.formerJobHistoryTmpkDeadline = response.data.formerJobHistoryTmpkDeadline
                    //if (this.tpmkDeadline == null) {
                    //    this.tpmkDeadline = this.formerJobHistoryTmpkDeadline
                    //}
                } else {
                    this.$bvModal.hide("jobNextFormModal");
                    this.$WarningAlert(response.data.resultMessage);
                }
            });
        },
        clear() {
            this.jobId = 0;
            this.recordId = 0;
            this.moduleId = 0;
            this.hiddenCheck = true;
            this.isRequired2 = false;
            this.applicationNo = "";
            this.hiddenCheckDocumentNo = true;
            this.isRequiredDocumentNo = false;
            this.hiddenTrademarkObjectionToUsRow = false;
            this.date = null
            this.nextJobDeadline = null
            this.tpmkDeadline = null
            this.jobNextStatusRelationDetailSelect = 0,
                this.hiddenPatentTranslateRow = false;
        },
        addOrUpdate() {
            const data = {
                jobStatusRelationId: this.jobNextStatusRelationDetailSelect,
                employeeId: this.employeeSelect,
                note: this.note,
                nextJobDeadline: this.nextJobDeadline,
                tpmkDeadline: this.tpmkDeadline,
                date: this.date,
                jobId: this.jobId,
                documentNo: this.documentNo,
                documentId: this.documentId,
            };
            const controller = {
                name: "JobHistory",
            };
            const payload = {
                data: data,
                controller: controller,
            };
            this.$refs.simpleRules.validate().then((success) => {
                if (success) {
                    let loader = this.$loading.show()
                    this.$store.dispatch("moduleAuth/save", payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide("jobNextFormModal");
                            if (this.getJobList != null) {
                                this.getJobList();
                            }
                            if (this.getJobReportList != null) {
                                this.getJobReportList();
                            }
                            if (this.hiddenCheck == true) {
                                const data = {
                                    moduleId: this.moduleId,
                                    recordId: this.recordId,
                                    applicationNo: this.applicationNo,
                                    processDate: this.date,
                                    documentId: this.documentId,
                                };
                                const controller = {
                                    name: "JobHistory",
                                    actionName: "UpdateRecordWhenJobApplicationAndMuvOut",
                                };
                                const payload = {
                                    data: data,
                                    controller: controller,
                                };
                                this.$store
                                    .dispatch("moduleAuth/customService", payload)
                                    .then((response) => {
                                        if (response.data.resultStatus != true) {
                                            this.$WarningAlert(response.data.resultMessage);
                                            loader.hide()
                                        }
                                    });
                            }

                            if (this.hiddenTrademarkObjectionToUsRow == true) {
                                const data = {
                                    id: 0,
                                    trademarkId: this.recordId,
                                    date: this.trademarkObjectionToUsDate,
                                    owner: this.trademarkObjectionToUsOwner,
                                    groundOfObjection: this.trademarkObjectionToUsGroundOfObjection,
                                    jobId: this.jobId
                                };

                                const controller = {
                                    name: "TrademarkObjectionToUs",
                                };
                                const payload = {
                                    data: data,
                                    controller: controller,
                                };
                                this.$store
                                    .dispatch("moduleAuth/save", payload)
                                    .then((response) => {
                                        if (response.data.resultStatus != true) {
                                            this.$WarningAlert(response.data.resultMessage);
                                            loader.hide()
                                        }
                                    });
                            }

                            if (this.getRecordInfo != null) {
                                this.getRecordInfo();
                            }
                            this.$bvModal.hide("jobNextFormModal");
                            this.$SaveAlert();
                            this.clear();
                            loader.hide()
                        } else {
                            this.$WarningAlert(response.data.resultMessage);
                        }
                        loader.hide()
                    })
                }
            });
        },
        async closeJob(id) {
            const data = {
                job: {
                    id: this.jobId,
                    isDone: true,
                },
            };
            const controller = {
                name: "Job",
                actionName: "CloseJob",
            };
            const payload = {
                data: data,
                controller: controller,
            };

            this.$PrivateConfirm(
                this.$t("jobNext.confirm_title"),
                this.$t("jobNext.confirm_message"),
                "warning",
                this.$t("jobNext.confirm_button_text"),
                this.$t("jobNext.cancel_button_text")
            ).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("moduleAuth/customService", payload)
                        .then((response) => {
                            if (response.data.resultStatus == true) {
                                this.$SaveAlert();
                                if (this.getJobList != null) {
                                    this.getJobList();
                                }
                                if (this.getJobReportList != null) {
                                    this.getJobReportList();
                                }
                                if (this.getRecordInfo != null) {
                                    this.getRecordInfo();
                                }
                            } else {
                                this.$WarningAlert(response.data.resultMessage);
                                if (this.getJobList != null) {
                                    this.getJobList();
                                }
                                if (this.getJobReportList != null) {
                                    this.getJobReportList();
                                }
                                if (this.getRecordInfo != null) {
                                    this.getRecordInfo();
                                }
                            }
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss">
[dir="ltr"] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
